<template>
  <container
    subHeaderTitle="핀브릿지 서비스<br /><b>환불 신청</b>"
    subHeaderText="가입자의 정보 확인이 꼭 필요합니다.<br />본인의 정보를 정확히 입력하시기 바랍니다."
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="4" sm="6">
            <v-form v-model="valid" ref="form" onsubmit="return false;">
              <p class="input-label first-input-label">통신사 선택<span> *</span></p>
              <v-btn-toggle color="primary" borderless mandatory v-model="mediaToggle" class="mt-4 teleco-text">
                <v-btn style="letter-spacing: -1px;" value="skt">SKT</v-btn>
                <v-btn style="letter-spacing: -1px;" value="kt">KT</v-btn>
                <v-btn style="letter-spacing: -1px;" value="lgu">LGU+</v-btn>
              </v-btn-toggle>

              <p class="input-label">서비스 선택<span> *</span></p>
              <v-radio-group v-model="selectedService" row class="mt-4 service-radio-group" :rules="[v => !!v || '서비스를 선택해주세요.']">
                <v-radio :value="resolveSafeguardServiceName(media)">
                  <template v-slot:label>
                    <span style="letter-spacing: -1px;">세이프가드(금융사기방지)</span>
                  </template>
                </v-radio>
                <v-radio value="정보유출안심케어">
                  <template v-slot:label>
                    <span style="letter-spacing: -1px;">정보유출안심케어</span>
                  </template>
                </v-radio>
                <v-radio v-if="isServiceAvailableForMedia('PASS프라임', media)" value="PASS프라임">
                  <template v-slot:label>
                    <span style="letter-spacing: -1px;">PASS 프라임</span>
                  </template>
                </v-radio>
                <v-radio v-if="isServiceAvailableForMedia('전월세안심케어', media)" value="전월세안심케어">
                  <template v-slot:label>
                    <span style="letter-spacing: -1px;">전월세안심케어</span>
                  </template>
                </v-radio>
                <v-radio v-if="isServiceAvailableForMedia('금융튜터', media)" value="금융튜터">
                  <template v-slot:label>
                    <span style="letter-spacing: -1px;">금융튜터</span>
                  </template>
                </v-radio>
              </v-radio-group>

              <p class="input-label">환불 사유<span> *</span></p>
              <v-radio-group v-model="selectedReason" row class="mt-4 reason-radio-group" :rules="[v => !!v || '환불 사유를 선택해주세요.']">
                <v-radio value="미인지 가입">
                  <template v-slot:label>
                    <span style="letter-spacing: -1px;">미인지 가입</span>
                  </template>
                </v-radio>
                <v-radio value="서비스 불만족">
                  <template v-slot:label>
                    <span style="letter-spacing: -1px;">서비스 불만족</span>
                  </template>
                </v-radio>
                <v-radio value="기타">
                  <template v-slot:label>
                    <span style="letter-spacing: -1px;">기타</span>
                  </template>
                </v-radio>
              </v-radio-group>

              <div class="divider"></div>
              <div class="refund-sub-title">환불계좌 정보</div>
              <p class="input-label">계좌 명의<span> *</span></p>
              <v-radio-group v-model="selectedBankOwnerType" row class="mt-4 account-owner-radio-group">
                <v-radio value="본인">
                  <template v-slot:label>
                    <span style="letter-spacing: -1px;">본인 명의</span>
                  </template>
                </v-radio>
                <v-radio value="타인">
                  <template v-slot:label>
                    <span style="letter-spacing: -1px;">타인 명의</span>
                  </template>
                </v-radio>
              </v-radio-group>

              <div v-if="selectedBankOwnerType === '타인'">
                <p class="input-label">생년월일<span> *</span></p>
                <v-text-field v-model="bankOwnerBirth" :rules="rules.birthRules" label="19990101" mask="########" solo class="mt-4" maxlength="8" validate-on-blur/>
                <p class="input-label">성별<span> *</span></p>
                <v-btn-toggle color="primary" borderless mandatory v-model="bankOwnerGender" class="mb-10 mt-4 gender-toggle">
                  <v-btn value="남">남</v-btn>
                  <v-btn value="여">여</v-btn>
                </v-btn-toggle>
              </div>

              <p class="input-label">은행명<span> *</span></p>
              <v-text-field
                  ref="bankNameField"
                  v-model="bankName"
                  :rules="rules.bankNameRules"
                  label="은행을 선택해 주세요."
                  solo
                  class="mt-4"
                  readonly
                  validate-on-blur
                  @click="openBankDialog"
              >
                <template v-slot:append>
                  <img
                      src="@/assets/img/icon-magnifier.png"
                      alt="Magnifier Icon"
                      class="magnifier-icon"
                  />
                </template>
              </v-text-field>
              <p class="input-label">계좌번호<span> *</span></p>
              <v-text-field v-model="bankAccount" :rules="rules.bankAccountRules" label="계좌번호를 입력해 주세요." solo class="mt-4" validate-on-blur/>
              <p class="input-label">예금주<span> *</span></p>
              <v-text-field v-model="bankOwnerName" :rules="rules.bankAccountOwnerRules" label="예금주 성함을 입력해 주세요." solo class="mt-4" validate-on-blur/>

              <div class="divider"></div>
              <div class="refund-sub-title">고객 정보</div>
              <p class="input-label">이름<span> *</span></p>
              <v-text-field v-model="name" :rules="rules.nameRules" label="실명으로 입력해 주세요." solo class="mt-4" validate-on-blur/>
              <p class="input-label">생년월일<span> *</span></p>
              <v-text-field v-model="birth" :rules="rules.birthRules" label="19990101" mask="########" solo class="mt-4" maxlength="8" validate-on-blur/>
              <p class="input-label">성별<span> *</span></p>
              <v-btn-toggle color="primary" borderless mandatory v-model="genCd" class="mb-10 mt-4 gender-toggle">
                <v-btn value="남">남</v-btn>
                <v-btn value="여">여</v-btn>
              </v-btn-toggle>
              <p class="input-label">휴대폰 번호<span> *</span></p>
              <div class="d-flex mt-4">
                <v-text-field
                  v-model="cellTelNo"
                  :rules="rules.cellTelNoRules"
                  label="‘-’를 제외하고 입력해 주세요."
                  mask="###########"
                  solo
                  maxlength="11"
                  validate-on-blur
                />
                <v-btn
                    :class="requestOtpBtnClass"
                    @click="requestSmsCert"
                    :disabled="isOtpSendRequested"
                >
                  {{ requestOtpBtnText }}
                </v-btn>
              </div>
              <!-- 인증번호 입력 (SMS 전송 성공 후 표시) -->
              <div v-if="showCertField">
                <v-text-field
                    v-model="certNum"
                    ref="certNum"
                    label="인증번호 입력"
                    mask="#####"
                    :rules="rules.certNumRules"
                    solo
                    maxlength="6"
                    class="cert-input-field mt-4"
                    validate-on-blur
                >
                  <template v-slot:append>
                    <span class="countdown-text">{{ countdown }}</span>
                  </template>
                </v-text-field>
              </div>
              <div v-if="media === 'skt'" class="reblock-section">
                <div class="divider"></div>
                <p class="input-label">재가입 차단 신청</p>
                <v-checkbox
                    v-model="isReBlockChecked"
                    hide-details
                    class="reblock-checkbox"
                    off-icon="mdi-radiobox-blank"
                    on-icon="mdi-radiobox-marked"
                >
                  <template v-slot:label>
                    <span style="letter-spacing: -1px;">차단 신청</span>
                  </template>
                </v-checkbox>
                <ul class="reblock-info-list">
                  <li>차단 기간: 신청일로부터 3년간 유료 재가입이 제한됩니다.</li>
                  <li>개인정보 수집·이용: 이름, 생년월일, 휴대폰번호, 신청/해제 일시, 차단 기간, 처리 이력을 재가입 차단 설정·관리 및 고객 요청 처리(민원 처리 포함)를 위해 이용하며, 3년간 보관 후 파기합니다.</li>
                  <li>유의사항: 해제는 고객센터(1688-4102)에서 가능합니다. 이름·휴대폰번호 등 고객 정보가 변경될 경우 차단이 해제되거나 적용되지 않을 수 있습니다.</li>
                </ul>
              </div>
              <div class="terms-container">
                <v-checkbox v-model="isTermsChecked" hide-details label="개인정보 수집 및 이용 동의(필수)" style="margin-top: 0;"></v-checkbox>
                <img src="@/assets/img/icon-grey-chevron-right.png" alt="Chevron Icon" class="chevron-icon" @click.stop="openTermsDialog"/>
              </div>
              <div class="recaptcha-area">
                <vue-recaptcha ref="recaptcha" v-model="recaptchaVerify" @verify="onVerify" @expired="onExpired" :sitekey="$cfg.recaptchaSiteKey"></vue-recaptcha>
                <div class="v-messages theme--light error--text mt-2">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message" v-if="!recaptchaVerifyCheck">로봇이 아닙니다를 체크해주세요</div>
                  </div>
                </div>
              </div>
              <div>
                <v-btn class="submit" rounded block large depressed v-on:click="submit" :class="requestRefundBtnClass"
                       :data-ga-category="gaEvent.category.support.safeguard.termi.name" :data-ga-label="gaEvent.category.support.safeguard.termi.label1" :data-ga-action="gaEvent.actions.buttonClick"
                       :disabled="isRefundRequested"
                >{{ requestRefundBtnText }}</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- 은행 선택 모달 -->
    <v-dialog v-model="isBankDialogOpen" max-width="500" max-height="520">
      <v-card style="height: 100%; overflow-y: auto;">
        <v-card-title class="bank-dialog-header">환불받을 계좌의 은행을 선택해주세요.</v-card-title>

        <!-- 은행 리스트 -->
        <v-card-text class="bank-dialog-content">
          <v-container>
            <v-row>
              <v-col
                  v-for="bank in bankOptions"
                  :key="bank.code"
                  cols="4"
                  class="bank-dialog__item"
                  @click="setSelectedBank(bank)"
                  :class="{ 'bank-dialog__item--selected': bank.code === selectedBankCode }"
              >
                <v-img
                    :src="bank.icon"
                    alt="은행 아이콘"
                    max-width="32"
                    max-height="32"
                    class="mx-auto"
                ></v-img>
                <p class="bank-dialog-name text-center mt-1">{{ bank.name }}</p>
              </v-col>
            </v-row>
          </v-container>

          <div class="bank-dialog-footer">
            <v-btn
                :class="selectBankBtnClass"
                block
                large
                rounded
                @click="applySelectedBank"
            >
              선택하기
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 원버튼, 투버튼 모달 -->
    <v-dialog v-model="isAlertModalOpen" max-width="295" class="alert-modal">
      <v-card>
        <v-card-title class="alert-modal-title" v-html="modalTitle"></v-card-title>
        <v-card-text v-if="modalMessage !== null" class="alert-modal-message" v-html="modalMessage"></v-card-text>
        <v-card-actions class="alert-modal-buttons">
          <v-btn v-if="modalType === 'one-button'" class="alert-modal-primary-button" @click="primaryButton.onClick">
            {{ primaryButton.text }}
          </v-btn>

          <v-btn v-if="modalType === 'two-button'" class="alert-modal-secondary-button" @click="secondaryButton.onClick">
            {{ secondaryButton.text }}
          </v-btn>
          <v-btn v-if="modalType === 'two-button'" class="alert-modal-primary-button" @click="primaryButton.onClick">
            {{ primaryButton.text }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--약관 모달 -->
    <TermsDialog
        :isShow="isTermsDialogVisible"
        :termTitle="termTitle"
        :termContent="termContent"
        :isExternalTerm=false
        :externalTermUrl=false
        :hasDownload=false
        @close="closeTermsDialog"
    />

  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/cscenter";
/* 모바일 서브헤더 타이틀 30px (Figma), 데스크탑은 Container 기본값 40px 유지 */
::v-deep .sub-header-title {font-size: 30px !important;line-height: 1.2 !important;letter-spacing: -2px !important;}
@media (min-width: 960px) {
  ::v-deep .sub-header-title {font-size: 40px !important;}
}

/* cscenter.scss의 .form-area p (13/14px) 우선순위를 이기기 위해 !important 필요 */
.refund-sub-title {font-size: 24px !important;font-weight: 500;line-height: 30px;letter-spacing: -1px;color: #001523;margin-bottom: 30px;}
/* 섹션 간 간격 40px (Figma gap-[40px]). 첫 라벨만 0 */
.input-label {margin-top: 40px !important;font-size: 18px !important;font-weight: 400;line-height: 30px;letter-spacing: -1px;text-align: left;color: #001523;}
.input-label.first-input-label {margin-top: 0 !important;}
.input-label span {color: #FF0000;}
.divider {border: 1px solid #DDDFE5;margin: 40px 0;}

/* v-input 내부 bottom space 제거 - 섹션 간 40px 간격이 깔끔하게 적용되도록 */
/* v-messages는 검증 오류 표시용이라 제거 불가, min-height만 0으로 만들어 비었을 때 공간 차지 안 함 */
.form-area ::v-deep .v-input .v-input__slot {margin-bottom: 0;}
.form-area ::v-deep .v-input .v-text-field__details {min-height: 0;}
.form-area ::v-deep .v-input .v-messages {min-height: 0;}

/* v-text-field (solo) - Figma: 62px 높이, 8px border-radius, 그림자 제거, transparent border (에러 시 빨강) */
.form-area ::v-deep .v-text-field--solo .v-input__slot {min-height: 62px;border-radius: 8px;box-shadow: none !important;border: 1px solid transparent;}
.form-area ::v-deep .v-text-field--solo.error--text .v-input__slot {border-color: #FF0000 !important;}
/* 에러 발생 시 입력창 ↔ 오류 메시지 8px 간격 (Figma) */
.form-area ::v-deep .v-input.error--text .v-messages {padding-top: 8px;}
/* v-text-field__details 좌측 패딩 제거 (Figma: 메시지 input 좌측 끝에서 시작) */
.form-area ::v-deep .v-text-field__details {padding-left: 0;padding-right: 0;}
/* 오류 메시지 폰트 13px, 색상 #FF0000 (Figma) */
.form-area ::v-deep .v-messages__message {font-size: 13px !important;color: #FF0000 !important;letter-spacing: -1px;line-height: 1;}

/* 라디오 그룹 에러 발생 시에도 라벨 텍스트는 #001523 유지 (Vuetify 기본 에러시 빨강 → 검정) */
.form-area ::v-deep .v-input--radio-group.error--text .v-label,
.form-area ::v-deep .v-input--radio-group.error--text .v-radio .v-label {color: #001523 !important;}

/* 라디오 그룹 에러 발생 시에도 라디오 아이콘(테두리) 색상 유지 - Figma는 에러 시 라디오 색 변경 없음 */
/* 선택: #006FBC, 비선택: Vuetify 기본 회색 */
.form-area ::v-deep .v-input--radio-group .v-radio.v-item--active .v-icon {color: #006FBC !important;}
.form-area ::v-deep .v-input--radio-group.error--text .v-radio:not(.v-item--active) .v-icon {color: rgba(0, 0, 0, 0.54) !important;}

/* 입력 필드 / 라디오 / 체크박스 폰트 18px */
::v-deep .v-text-field input {font-size: 18px;}
::v-deep .v-text-field .v-label {font-size: 18px;color: #AEBAC1;}
::v-deep .v-radio .v-label {font-size: 18px;color: #001523;letter-spacing: -1px;}
::v-deep .v-input--checkbox .v-label {font-size: 18px;color: #001523;letter-spacing: -1px;}

/* 통신사 선택 / 성별 토글 - 비활성 #AEBAC1, 활성 #006FBC */
.teleco-text ::v-deep .v-btn,
.gender-toggle ::v-deep .v-btn {font-size: 18px !important;letter-spacing: -1px;height: 62px !important;}
.teleco-text ::v-deep .v-btn:not(.v-btn--active) .v-btn__content,
.gender-toggle ::v-deep .v-btn:not(.v-btn--active) .v-btn__content {color: #AEBAC1 !important;}
.teleco-text ::v-deep .v-btn--active .v-btn__content,
.gender-toggle ::v-deep .v-btn--active .v-btn__content {color: #006FBC !important;}

/* 돋보기 아이콘 - v-text-field append 슬롯이 자동 vertical center 처리 */
.magnifier-icon {width: 24px;height: 24px;pointer-events: none;}

.request-otp-btn {width: 100px;height: 62px !important;min-height: 62px !important;padding: 0 8px !important;margin: 0 0 0 8px;border-radius: 8px;font-size: 18px;font-weight: 400;line-height: 30px;letter-spacing: -1px;box-shadow: none;}
.request-otp-btn--default {background-color: #006FBC !important;color: #FFFFFF !important;}
.request-otp-btn--resend {background-color: #F0F2F3 !important;color: #001523 !important;}

.cert-input-field {width: 100%;}
/* 카운트다운 - v-text-field append 슬롯이 자동 vertical center 처리 */
.countdown-text {font-size: 16px;color: #006FBC;letter-spacing: -1px;line-height: 1;pointer-events: none;}

/* 라디오 그룹 - 모바일 기본: 세로 정렬 (gap 16px) */
.service-radio-group ::v-deep .v-input--radio-group__input,
.reason-radio-group ::v-deep .v-input--radio-group__input,
.account-owner-radio-group ::v-deep .v-input--radio-group__input {display: flex;flex-direction: column;gap: 16px;}
.service-radio-group ::v-deep .v-radio,
.reason-radio-group ::v-deep .v-radio,
.account-owner-radio-group ::v-deep .v-radio {margin-right: 0 !important;margin-bottom: 0 !important;}

/* 라디오 그룹 - 데스크탑(md+): 그리드 layout */
@media (min-width: 960px) {
  .service-radio-group ::v-deep .v-input--radio-group__input {display: grid;grid-template-columns: repeat(2, 1fr);row-gap: 16px;column-gap: 0;}
  .reason-radio-group ::v-deep .v-input--radio-group__input {display: grid;grid-template-columns: repeat(3, 1fr);row-gap: 16px;column-gap: 0;}
  .account-owner-radio-group ::v-deep .v-input--radio-group__input {display: grid;grid-template-columns: repeat(2, 1fr);row-gap: 16px;column-gap: 0;}
}

/* 재가입 차단 신청 - 다음 섹션(약관 동의)과 40px 간격 */
.reblock-section {margin-bottom: 40px;}
/* 라벨(재가입 차단 신청) ↔ 차단 신청 버튼: 16px (Figma) */
.reblock-checkbox {margin-top: 16px !important;padding-top: 0 !important;}
.reblock-checkbox ::v-deep .v-label {font-size: 18px;color: #001523;letter-spacing: -1px;}
.reblock-checkbox ::v-deep .v-icon {color: #999 !important;font-size: 24px;}
.reblock-checkbox.v-input--is-label-active ::v-deep .v-icon {color: #006FBC !important;}

/* 재가입 차단 안내문 - 좌/우 padding 20px (disc 포함), 차단신청 ↔ 안내문: 20px (Figma) */
.reblock-info-list {list-style: none;padding: 0 20px;margin: 20px 0 0 !important;}
.reblock-info-list li {position: relative;padding-left: 14px;margin-bottom: 10px;font-size: 13px !important;font-weight: 400;line-height: 1.7;letter-spacing: -1px;color: #9B9FA8;}
.reblock-info-list li::before {content: "•";position: absolute;left: 0;top: 0;line-height: 1.7;}
.reblock-info-list li:last-child {margin-bottom: 0;}

.terms-container {display: flex;align-items: flex-end;}
.terms-checkbox {margin-right: auto;}
.chevron-icon {width: 24px;height: 24px;margin-left: auto;display: block;}

/* Figma: padding 16px (위아래) - 환불 신청 버튼 (text 24px + padding 32 = 56px) */
.request-refund-btn {font-size: 24px !important;font-weight: 400;line-height: 24px;letter-spacing: -2px;text-align: center;height: auto !important;min-height: 56px !important;padding: 16px !important;}
.request-refund-btn--default {background-color: #006FBC !important;color: #FFFFFF !important;}
.request-refund-btn--disable {background-color: #F0F2F3 !important;color: #001523 !important;}

.bank-dialog-header {font-size: 1rem !important;font-weight: 500;line-height: 27px;letter-spacing: -0.025rem !important;padding: 18px 15px !important;border-bottom: none !important;box-shadow: none !important;}
.bank-dialog-content {width: 100%;height: 445px;overflow-y: auto;padding:0 8px 0 !important;-ms-overflow-style: none;scrollbar-width: none;}
.bank-dialog-content::-webkit-scrollbar {display: none;}
.bank-dialog-name {font-size: 0.8125rem;font-weight: 400;line-height: 1.25rem;color: #18181A;}
.bank-dialog__item {text-align: center;border:1.5px solid #FFF;border-radius: 16px;box-sizing: border-box;}
.bank-dialog__item img {max-width: 32px;max-height: 32px;display: block;margin: 0 auto;}
.bank-dialog__item--selected {border-radius: 16px;border: 1.5px solid #001523;background-color: #F5F6FA;}
.bank-dialog-footer {position: sticky;bottom: 0;z-index: 10;width: 100%;padding: 4px 12px 16px 12px;}
.bank-dialog-btn-text {font-size: 1rem;font-weight: 500;line-height: 1.25rem;letter-spacing: -1px;text-align: center;}
.bank-dialog-btn--enabled {background-color: #006FBC !important;color: #FFFFFF;box-shadow: none;}
.bank-dialog-btn--disabled {background-color: #DDDFE5 !important;color: #FFFFFF;box-shadow: none;}

.alert-modal {z-index: 200;}
.alert-modal-title {font-size: 1rem !important;font-weight: 600;letter-spacing: -0.02rem !important;text-align: center;justify-content: center;align-items: center;}
.alert-modal-message {font-size: 0.78rem;font-weight: 400;color: #5C616B;line-height: 1.25rem;text-align: center;justify-content: center;align-items: center;padding-bottom: 10px !important;}
.alert-modal-buttons {display: flex;justify-content: space-around;width: 100%;box-shadow: none !important;padding:8px 20px 16px 20px !important;}
.alert-modal-primary-button, .alert-modal-secondary-button {flex: 1;min-height:50px;font-size: 0.89rem;font-weight: 600;border-radius: 8px;padding: 10px 20px;box-shadow: none;letter-spacing: -0.02rem !important;}
.alert-modal-primary-button {background-color: #25282E !important;color: #FFFFFF !important;}
.alert-modal-secondary-button {background-color: #F5F6FA !important;color: #858994 !important;}

/* 위에서 .form-area ::v-deep로 처리됨 - 이 규칙들은 ::v-deep 없이는 scoped CSS로 인해 적용 안 됨 */
.v-input__control, .v-input__slot, .v-select__slot {color: #006FBC !important;}
.mdi-radiobox-marked {color: #006FBC !important;}
.teleco-text { letter-spacing: -1px;}


</style>

<script>
import Container from "@/pages/container/index.vue";
import Refund from "@/views/csCenter/Refund";
import TermsDialog from "@/pages/components/TermsDialog";

const MEDIA_RESTRICTED_SERVICES = {
  'PASS프라임': ['skt'],
  '금융튜터': ['skt'],
};

export default {
  mixins: [Refund],
  name: "Refund",
  components: {
    Container,
    TermsDialog
  },
  data() {
    return {
      valid: false,
      recaptchaVerify: false,
      recaptchaVerifyCheck: true,
      selectedService: '',
      selectedReason: '',
      selectedBankOwnerType: '본인',
      name: '',
      birth: '',
      mediaToggle: 'skt',

      genCd: '남',
      cellTelNo: '',
      bankAccount: '',
      bankOwnerName: '',
      bankOwnerBirth: '',
      bankOwnerGender: '남',
      isOtpSendRequested: false,
      requestOtpSent: false,
      showCertField: false,
      certNum: '',
      countdown: "3:00",
      endTime: null,
      isTermsChecked: false,
      isReBlockChecked: false,
      selectedBankName: '',
      selectedBankCode: '',
      bankName: '',
      bankCode: '',
      isBankDialogOpen: false,
      bankOptions: [
        {name: "국민은행", code: "004", icon: require("@/assets/img/bank/icon-kb.png")},
        {name: "우리은행", code: "020", icon: require("@/assets/img/bank/icon-woori.png")},
        {name: "하나은행", code: "081", icon: require("@/assets/img/bank/icon-hana.png")},
        {name: "신한은행", code: "088", icon: require("@/assets/img/bank/icon-shinhan.png")},
        {name: "KDB산업은행", code: "002", icon: require("@/assets/img/bank/icon-kdb.png")},
        {name: "기업은행", code: "003", icon: require("@/assets/img/bank/icon-ibk.png")},
        {name: "NH농협", code: "011", icon: require("@/assets/img/bank/icon-nh.png")},
        {name: "농축협", code: "012", icon: require("@/assets/img/bank/icon-nh.png")},
        {name: "SC제일은행", code: "023", icon: require("@/assets/img/bank/icon-sc.png")},
        {name: "대구은행", code: "031", icon: require("@/assets/img/bank/icon-dgb.png")},
        {name: "부산은행", code: "032", icon: require("@/assets/img/bank/icon-bnk.png")},
        {name: "광주은행", code: "034", icon: require("@/assets/img/bank/icon-jeonbook.png")},
        {name: "제주은행", code: "035", icon: require("@/assets/img/bank/icon-shinhan.png")},
        {name: "전북은행", code: "037", icon: require("@/assets/img/bank/icon-jeonbook.png")},
        {name: "경남은행", code: "039", icon: require("@/assets/img/bank/icon-bnk.png")},
        {name: "새마을금고", code: "045", icon: require("@/assets/img/bank/icon-saemaeul.png")},
        {name: "신협", code: "048", icon: require("@/assets/img/bank/icon-shinhyeop.png")},
        {name: "우체국", code: "071", icon: require("@/assets/img/bank/icon-post.png")},
        {name: "카카오뱅크", code: "090", icon: require("@/assets/img/bank/icon-kakaobank.png")},
        {name: "케이뱅크", code: "089", icon: require("@/assets/img/bank/icon-kbank.png")},
        {name: "토스뱅크", code: "092", icon: require("@/assets/img/bank/icon-toss.png")},
      ],
      isTermsDialogVisible: false,
      termTitle: "개인정보 수집/이용 동의서", // 약관 제목
      termContent: "<p><h4 class=\"terms-subtitle\">개인정보 수집 및 이용동의서</h4><br>" +
          "    본 신청인은 작성한 개인정보가 사실임을 확인하며, 위와 같이 개인정보 수집·이용·보유에 동의합니다." +
          "    신청인은 동의를 거부할 권리가 있으나, 동의하지 않으실 경우 환불이 제한될 수 있음을 알려드립니다.<br><br></p>" +
          "  <p>본 신청과 관련하여 회사가 본인의 개인정보를 수집·이용하고자 하는 경우에는 『개인정보보호법』 제15조, 제22조에 따라 본인의 동의를 얻어야 합니다.<br><br></p>\n" +
          "  <h4 class=\"terms-subtitle\">• 수집·이용목적</h4>" +
          "  <p>본인확인, 환불처리, 환불관련 고객민원처리</p><br>" +
          "  <h4 class=\"terms-subtitle\">• 수집·이용할 개인정보의 내용</h4>" +
          "  <p>고객명, 생년월일, 연락처, 은행명, 입금계좌번호, 예금주</p><br>" +
          "  <h4 class=\"terms-subtitle\">• 보유 및 이용기간</h4>" +
          "  <p>수집·이용 목적 달성 후 파기처리 (단, 민원 분쟁 소지로 인해 아래 기간 동안 보존)</p>" +
          "  <p>- 보존기간: 환불 접수 후 1년</p>" +
          "  <p>- 보존사유: 환불금액 정산 및 고객민원 또는 분쟁처리에 관한 기록, 소송 등 기타 필요한 경우 대비</p>" +
          "  <p>- 파기절차: 보존기간 만료 시 개인정보처리방침에 따라 파기 처리</p>",
      isAlertModalOpen: false,
      modalTitle: '',
      modalMessage: '',
      modalType: '',
      primaryButton: {
        text: '',
        color: '',
        onClick: null,
      },
      secondaryButton: {
        text: '',
        color: '',
        onClick: null,
      },
      isRefundRequested: false,
      rules: {
        nameRules: [v => !!v || "이름을 입력해 주세요."],
        bankNameRules: [v => !!v || "은행을 선택해 주세요."],
        bankAccountRules: [
          v => !!v || "계좌번호를 입력해 주세요.",
          v => (v && v.length >= 10) || "계좌번호를 다시 확인해 주세요."
        ],
        bankAccountOwnerRules: [v => !!v || "예금주 성함을 입력해 주세요."],
        birthRules: [
          v => !!v || "생년월일을 입력하세요.",
          v => (v && v.length >= 8 && /((1|2)[0-9]{3})(0[1-9]{1}|1[0-2]{1})(0[1-9]|(1|2)[0-9]{1}|3[0-1]{1})$/.test(v)) || "생년월일이 정확하지 않습니다."
        ],
        cellTelNoRules: [
          v => !!v || "휴대폰번호를 입력해 주세요.",
          v =>
              (v &&
                  v.length >= 11 &&
                  /(01[0])([1-9]{1}[0-9]{2,3})([0-9]{4})$/.test(v)) ||
              "휴대폰 번호를 입력해 주세요."
        ],
        certNumRules: [
          v => !!v || "인증번호를 입력하세요.",
        ],
      },
    };
  },
  watch: {
    selectedService(newVal, oldVal) {
      // OTP 인증은 서비스 컨텍스트에도 종속되므로, 서비스 변경 시 진행 중인 인증 상태를 초기화한다.
      // (미초기화 시 다른 서비스로 발급받은 인증번호가 새 서비스로 제출될 수 있음)
      if (oldVal && newVal !== oldVal) {
        this.resetOtpVerification();
      }
    },
    selectedBankOwnerType(newVal) {
      if (newVal === '본인') {
        this.bankOwnerBirth = '';
        this.bankOwnerGender = '남';
      }
    },
    mediaToggle(newVal, oldVal) {
      // 세이프가드 계열은 통신사별 명칭이 다르므로, 통신사 변경 시 해당 통신사 명칭으로 동기화
      if (!this.selectedService || this.isSafeguardService(this.selectedService)) {
        this.selectedService = this.resolveSafeguardServiceName(this.media);
      }
      // 현재 선택한 서비스가 변경된 통신사에서 제공되지 않으면 세이프가드로 초기화
      if (!this.isServiceAvailableForMedia(this.selectedService, newVal)) {
        this.selectedService = this.resolveSafeguardServiceName(newVal);
      }
      // 재가입 차단은 SKT 전용이므로 SKT 이탈 시 해제
      if (oldVal === 'skt' && newVal !== 'skt') {
        this.isReBlockChecked = false;
      }
      // OTP 인증은 통신사·서비스 컨텍스트에 종속되므로, 통신사 변경 시 진행 중인 인증 상태를 초기화한다.
      // (미초기화 시 특정 통신사로 발급받은 인증번호가 다른 통신사로 제출될 수 있음)
      this.resetOtpVerification();
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
  },
  computed: {
    form() {
      return {
        name: this.name,
        birth: this.birth,
        cellTelNo: this.cellTelNo
      };
    },
    media() {
      return this.mediaToggle;
    },
    requestOtpBtnText() {
      return this.requestOtpSent ? "재전송" : "인증 요청";
    },
    requestOtpBtnClass() {
      return this.requestOtpSent ? "request-otp-btn request-otp-btn--resend" : "request-otp-btn request-otp-btn--default";
    },
    selectBankBtnClass() {
      if (this.selectedBankCode) {
        return 'bank-dialog-btn-text bank-dialog-btn--enabled';
      }
      return 'bank-dialog-btn-text bank-dialog-btn--disabled';
    },
    requestRefundBtnText() {
      return this.isRefundRequested ? "환불신청 처리 중입니다" : "환불 신청";
    },
    requestRefundBtnClass() {
      return this.isRefundRequested ? "request-refund-btn request-refund-btn--disable" : "request-refund-btn request-refund-btn--default";
    }
  },
  methods: {
    requestSmsCert() {
      if (!this.isTermsChecked) {
        this.showTwoButtonModal(
            '환불 처리를 위해<bR>약관 동의가 필요해요',
            null,
            '동의하기',
            () => {
              this.isTermsChecked = true;
              this.isAlertModalOpen = false;
              !this.requestOtpSent ? this.handleOtpSend() : this.handleOtpResend();
            },
            '닫기',
            () => {
              this.isAlertModalOpen = false;
              return false;
            } 
        );
        return false;
      }

      !this.requestOtpSent ? this.handleOtpSend() : this.handleOtpResend();
    },

    handleOtpSend() {
      this.$refs.form.validate();

      if (!this.valid) {
        // Scroll to the first invalid input
        this.$nextTick(() => {
          const errorEl = this.$el.querySelector('.v-input.error--text, .v-radio-group.error--text');
          if (errorEl) {
            errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
        return false;
      }

      this.sendSmsCert(this.getOtpTimerMinutes());
    },

    handleOtpResend() {
      let isValid = true;

      Object.keys(this.$refs.form.$refs).forEach(ref => {
        // 인증번호 필드 검증 제외
        if (ref !== 'certNum') {
          const fieldValid = this.$refs.form.$refs[ref].validate();
          if (!fieldValid) isValid = false;
        }
      });

      if (!isValid) {
        this.showOneButtonModal('필수 정보들을 모두 입력해 주세요', null, '확인', null);
        return false;
      }

      this.showTwoButtonModal(
          '인증번호를 재전송할까요?',
          '휴대폰 번호가 정확한지 확인해 주세요.',
          '재전송',
          () => {
            this.isAlertModalOpen = false;
            this.sendSmsCert(this.getOtpTimerMinutes());
          },
          '닫기',
          () => {
            this.isAlertModalOpen = false;
          }
      )
    },

    sendSmsCert(timerMinutes) {
      this.isOtpSendRequested = true;
      this.axios
          .post("/rest/refund/sms", {
            serviceType: this.selectedService,
            media: this.media,
            phoneNumber: this.cellTelNo,
            // 홈페이지 공통 환불계좌 검증용 (인증요청 단계에서 함께 전달)
            name: this.name,
            // 전월세(JWS)·금융튜터는 인증요청 단계에서 가입자 검증을 위해 생년월일이 필요. 타 서비스는 미사용
            birth: this.birth,
            bankOwnerType: this.selectedBankOwnerType,
            bankOwnerName: this.bankOwnerName,
            bankOwnerBirth: this.bankOwnerBirth,
            bankOwnerGender: this.bankOwnerGender,
            bankCode: this.bankCode,
            bankName: this.bankName,
            bankAccountNumber: this.bankAccount
          })
          .then(result => {
            if (!result.data.isSucceed) {
              switch (result.data.errorCode) {
                // 전월세·금융튜터는 인증요청 단계에서 가입자를 검증하므로 가입 정보 없음(E912)이 이 단계에서 온다
                case 'E912' :
                  this.showOneButtonModal(this.selectedService + '<br>가입 정보가 없어요', '환불받으실 서비스를 다시 확인해 주세요', '확인',null);
                  break;
                case 'E913' :
                  this.showOneButtonModal('계좌번호 조회를 실패했어요.', '은행과 계좌번호를 다시 확인해 주세요.', '확인',null);
                  break;
                case 'E914' :
                  this.showOneButtonModal('본인 명의의 계좌번호를 입력해 주세요', '은행과 계좌번호를 다시 확인해 주세요.', '확인',null);
                  break;
                case 'E915' :
                  this.showOneButtonModal('서비스 점검 중 이에요.', '나중에 다시 시도해 주세요.', '확인',null);
                  break;
                case 'E916' :
                  this.showOneButtonModal('현재 유료가입 중이에요', '환불 신청을 위해서는 먼저 서비스 해지를 해주세요.', '확인',null);
                  break;
                case 'E917' :
                  this.showOneButtonModal('이전에 신청한 환불 내역이 있어요', '환불 신청 처리 중입니다.<br>자세한 내용은 고객센터로 문의해주세요.', '확인',null);
                  break;
                case 'E918' :
                  this.showOneButtonModal('1일 인증 요청 횟수를 초과했어요', '내일 다시 시도하거나<br>고객센터로 문의해 주세요.', '확인',null);
                  break;
                case 'E999' :
                  this.showOneButtonModal('서비스 이용이 지연되고 있어요', '잠시 후 다시 시도해 주세요.', '확인',null);
                  break;
                default :
                  this.showOneButtonModal('오류가 발생했습니다.', '문제가 계속되면 잠시 후 다시 시도해 주세요.', '확인',null);
                  break;
              }
            } else {
              this.showCertField = true;
              this.requestOtpSent = true;
              this.startCountDownTimer(timerMinutes, 0);

              this.showOneButtonModal('휴대폰으로 인증번호가 발송됐어요',null, '확인', null);
            }
          })
          .catch(error => {
            this.showOneButtonModal('오류가 발생했습니다.', '문제가 계속되면 잠시 후 다시 시도해 주세요.', '확인',null);
          })
          .finally(() => {
            this.isOtpSendRequested = false;
          });
    },

    resolveSafeguardServiceName(media) {
      if (media === 'skt') return 'PASS세이프가드';
      if (media === 'kt') return '세이프가드_KT';
      return '금융사기방지';
    },

    isSafeguardService(serviceName) {
      return ['PASS세이프가드', '세이프가드_KT', '금융사기방지'].includes(serviceName);
    },

    // 통신사별 제공 서비스 노출 규칙 (서비스 라디오 v-if / 통신사 변경 시 초기화에서 공통 사용)
    isServiceAvailableForMedia(serviceName, media) {
      const allowedMedia = MEDIA_RESTRICTED_SERVICES[serviceName];
      return !allowedMedia || allowedMedia.includes(media);
    },

    getOtpTimerMinutes() {
      return ['PASS세이프가드', '금융사기방지'].includes(this.selectedService) ? 3 : 5;
    },

    // 진행 중인 OTP 인증 상태 초기화 (인증 요청 버튼·인증번호 입력창·카운트다운 리셋)
    // isOtpSendRequested(전송 in-flight 가드)는 sendSmsCert의 finally가 관리하므로 여기서 건드리지 않는다.
    // (초기화하면 전송 요청 진행 중 통신사 토글 시 중복 전송 창이 열림)
    resetOtpVerification() {
      this.requestOtpSent = false;
      this.showCertField = false;
      this.certNum = '';
      this.endTime = null;
      this.countdown = "3:00";
    },

    startCountDownTimer(minutes, seconds) {
      this.endTime = new Date().getTime() + minutes * 60000 + seconds * 1000;
      this.updateCountDownTimer();
    },

    updateCountDownTimer() {
      const now = new Date().getTime();
      const remaining = this.endTime - now;

      if (remaining > 0) {
        const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
        this.countdown = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
        setTimeout(this.updateCountDownTimer, 1000);
      } else {
        this.countdown = "0:00";
      }
    },

    openBankDialog() {
      this.isBankDialogOpen = true;
    },

    closeBankDialog() {
      this.isBankDialogOpen = false;
    },

    setSelectedBank(bank) {
      this.selectedBankCode = bank.code;
      this.selectedBankName = bank.name;
    },

    applySelectedBank() {
      if (!this.selectedBankCode) {
        return;
      }

      this.bankCode = this.selectedBankCode;
      this.bankName = this.selectedBankName;
      this.closeBankDialog();
      this.$nextTick(() => {
        if (this.$refs.bankNameField) this.$refs.bankNameField.resetValidation();
      });
    },

    submit(e) {
      this.gaTracking(e);
      this.recaptchaVerifyCheck = this.recaptchaVerify;
      this.$refs.form.validate();

      if (!this.valid) {
        return false;
      }
      if (!this.recaptchaVerify) {
        return false;
      }
      if (!this.requestOtpSent) {
        this.showOneButtonModal('휴대폰 인증을 해주세요', null, '확인', null);
        return false;
      }

      if (this.selectedBankOwnerType === '본인') {
        if (this.bankOwnerName !== this.name) {
          this.showOneButtonModal('본인 명의 계좌를 입력해주세요', '고객 명과 예금주 명이 맞지 않습니다.', '확인', null);
          return false;
        }
      }

      this.submitRefundRequest();
    },

    submitRefundRequest() {
      this.isRefundRequested = true;

      this.axios
          .post("/rest/refund", {
            serviceType: this.selectedService,
            media: this.media,
            phoneNumber: this.cellTelNo,
            name: this.name,
            birth: this.birth,
            gender: this.genCd,
            bankOwnerType: this.selectedBankOwnerType,
            bankOwnerName: this.bankOwnerName,
            bankOwnerBirth: this.bankOwnerBirth,
            bankOwnerGender: this.bankOwnerGender,
            bankCode: this.bankCode,
            bankName: this.bankName,
            bankAccountNumber: this.bankAccount ,
            otp: this.certNum,
            reason: this.selectedReason,
            blockRequested: this.isReBlockChecked
          })
          .then(result => {
            if (result.data.isSucceed) {
              this.$router.push({
                name: "RefundResult",
                params: { serviceType: this.selectedService }
              });
            } else {
              switch (result.data.errorCode) {
                case 'E910' :
                  this.showOneButtonModal('인증번호가 맞지 않아요', '인증번호를 다시 확인해 주세요.', '확인',null);
                  break;
                case 'E911' :
                  this.showOneButtonModal('입력시간이 초과되었어요', '인증번호 재전송 또는<br>휴대폰 번호를 다시 확인해 주세요.', '확인',null);
                  break;
                case 'E912' :
                  this.showOneButtonModal(this.selectedService + '<br>가입 정보가 없어요', '환불받으실 서비스를 다시 확인해 주세요', '확인',null);
                  break;
                case 'E913' :
                  this.showOneButtonModal('계좌번호 조회를 실패했어요.', '은행과 계좌번호를 다시 확인해 주세요.', '확인',null);
                  break;
                case 'E914' :
                  this.showOneButtonModal('본인 명의의 계좌번호를 입력해 주세요', '은행과 계좌번호를 다시 확인해 주세요.', '확인',null);
                  break;
                case 'E915' :
                  this.showOneButtonModal('서비스 점검 중 이에요.', '나중에 다시 시도해 주세요.', '확인',null);
                  break;
                case 'E916' :
                  this.showOneButtonModal('현재 유료가입 중이에요', '환불 신청을 위해서는 먼저 서비스 해지를 해주세요.', '확인',null);
                  break;
                case 'E917' :
                  this.showOneButtonModal('이미 환불 신청 내역이 있어요', '접수된 환불 신청이 처리 중이에요.', '확인',null);
                  break;
                case 'E999' :
                  this.showOneButtonModal('서비스 이용이 지연되고 있어요', '잠시 후 다시 시도해 주세요.', '확인',null);
                  break;
                default :
                  this.showOneButtonModal('오류가 발생했습니다.', '문제가 계속되면 잠시 후 다시 시도해 주세요.', '확인',null);
                  break;
              }
            }
          })
          .catch(error => {
            this.showOneButtonModal('오류가 발생했습니다.', '문제가 계속되면 잠시 후 다시 시도해 주세요.', '확인',null);
          })
          .finally(() => {
            this.isRefundRequested = false;
          });
    },

    goBack(e) {
      this.gaTracking(e);
      this.$router.push({ name: 'Support' });
    },

    openTermsDialog() {
      this.isTermsDialogVisible = true;
    },

    closeTermsDialog() {
      this.isTermsDialogVisible = false;
    },

    showOneButtonModal(title, message, primaryText, primaryAction) {
      this.modalTitle = title;
      this.modalMessage = message;
      this.modalType = 'one-button';
      this.primaryButton = {
        text: primaryText,
        onClick: primaryAction || (() => (this.isAlertModalOpen = false)),
      };
      this.isAlertModalOpen = true;
    },


    showTwoButtonModal(title, message, primaryText, primaryAction, secondaryText, secondaryAction) {
      this.modalTitle = title;
      this.modalMessage = message;
      this.modalType = 'two-button';
      this.primaryButton = {
        text: primaryText,
        onClick: primaryAction || (() => (this.isAlertModalOpen = false)),
      };
      this.secondaryButton = {
        text: secondaryText,
        onClick: secondaryAction || (() => (this.isAlertModalOpen = false)),
      };
      this.isAlertModalOpen = true;
    },
    //vue-recaptcha
    onVerify(r) {
      // console.log(r);
      this.recaptchaVerify = true;
      this.recaptchaVerifyCheck = this.recaptchaVerify
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },
    exec() {
      this.$refs.recaptcha.execute();
    },
    reset() {
      this.$refs.recaptcha.reset();
    },
    replaceNan(dataNm) {
      this[dataNm] = this[dataNm].replaceAll(/[^0-9]/g, "")
    }
  }
};
</script>
